import { makeRequestGet, makeRequestGet2, makeRequestPost2, makeRequestPut2 } from "../api";
import Cookies from "js-cookie";

function getToken() {
  return new Promise((resolve) => {
    const checkToken = () => {
      let token = Cookies.get("token");
      if (token) {
        resolve(token);
      } else {
        setTimeout(checkToken, 100); // Check again after 100ms
      }
    };
    checkToken();
  });
}

export async function getOffers() {
  let token = await getToken();
  return makeRequestGet2(`offers/`, token);
}
export async function allOffers() {

  return makeRequestGet2(`offers1/`);
}

export async function postOffers(data) {
  let token = await getToken();
  return makeRequestPost2(`offers/`, data, token);
}

export async function getOffer(id) {
  let token = await getToken();
  return makeRequestGet2(`offers/${id}`, token);
}

export async function putOffer(id, data) {
  let token = await getToken();
  return makeRequestPut2(`offers/${id}`, data, token);
}
